import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useGetProjectByIdQuery, V1ProjectLocationResource } from "@generated";
import { Project } from "../../types";

const useGetProjectById = (id) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  let customError: string | null = null; // Declare customError

  const { data, isLoading, error } = useGetProjectByIdQuery({
    slug: accountSlug,
    id,
    include: ["project-locations", "rate-table"],
  });

  let project: Project | undefined = undefined;

  if (data?.data) {
    try {
      const p = data.data;
      const locations =
        p.relationships?.["project-locations"]?.data
          ?.map((l) => {
            const location = data?.included?.find?.(
              (item) =>
                item.type === "project-locations" &&
                item.id == l.id &&
                //@ts-ignore
                item.attributes?.active
            ) as V1ProjectLocationResource;
            return {
              label: String(location?.attributes?.name || ""),
              value: String(location?.id || ""),
            };
          })
          ?.filter((l) => l.value) || [];
      if (p?.id && p?.relationships) {
        project = {
          id: p.id,
          status: p?.attributes?.status,
          locations,
          rateTableId: p.relationships?.["rate-table"]?.data?.id,
          executiveSummary: p?.attributes?.["executive-summary"],
          solutionSummary: p?.attributes?.["solution-summary"],
          ourResponsibilities: p?.attributes?.["our-responsibilities"],
          customerResponsibilities: p?.attributes?.["client-responsibilities"],
          outOfScope: p?.attributes?.["out-of-scope"],
        };
      }
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    project,
    isLoading,
    error: error ?? customError,
  };
};
export default useGetProjectById;
